import { PrincipalIdSchema } from "@core/domains/identity";
import { identity } from "@core/foundation/function";
import { ulid } from "@core/foundation/id";
import {
  createModel,
  createModelId,
  createModelSchemas,
  noModelUpdate,
} from "@core/foundation/model";
import { z } from "@core/zod";

import { MemoryIdSchema } from "./memory.ts";
import { ProjectIdSchema } from "./project.ts";
import { RevisionContentSchema } from "./revision/content.ts";
import { ID_PREFIX } from "./shared/id-prefix.ts";

const { generateId: generateRevisionId, idSchema: RevisionIdSchema } =
  createModelId({ digestFn: ulid, idPrefix: ID_PREFIX.REVISION });

export { RevisionIdSchema };

export const Revision = createModel({
  create: (item, schema) => {
    return { ...schema.decode(item), id: generateRevisionId() };
  },
  schemas: createModelSchemas({
    base: z.object(
      {
        content: RevisionContentSchema,
        id: RevisionIdSchema,
        memoryId: MemoryIdSchema,
        principalId: PrincipalIdSchema,
        projectId: ProjectIdSchema,
      },
      {
        content: "The memory's content as of this revision.",
        id: "The unique identifier for the revision.",
        memoryId: "The id of the memory the revision belongs to.",
        principalId: "The id of the principal the revision belongs to.",
        projectId: "The id of the project the revision belongs to.",
      },
    ),
    derive: {
      create: schema => schema.omit({ id: true }),
      recovery: identity,
      update: noModelUpdate,
    },
  }),
  update: (item, update, schema) => {
    return { ...item, ...schema.decode(update) };
  },
});

export interface Revision extends z.infer<typeof Revision.schema> {}
